import { Property } from "../../../../../RadObject";
import { EvaluatorList } from "../../../SeriouslyRAD.Framework/Evaluation/EvaluatorList";
import { EvaluatorListPropertyValues, IEvaluatorList } from "../../../SeriouslyRAD.Framework/Evaluation/IEvaluatorList";
import { NAMESPACE } from "./_Namespace";

export type OrEvaluatorPropertyValues =
    EvaluatorListPropertyValues
    & {
    };

export type OrEvaluatorProperties = {
    [name in keyof OrEvaluatorPropertyValues]: Property<OrEvaluatorPropertyValues[name]>
};

export interface IOrEvaluator extends IEvaluatorList, OrEvaluatorProperties
{
}

export class OrEvaluator extends EvaluatorList<OrEvaluatorPropertyValues> implements IOrEvaluator
{
    public static override classNamespace = NAMESPACE + "OrEvaluator";
    public static override className = "OrEvaluator";

    // #region Overrides

    public override evaluate()
    {
        const
            evaluators = this.evaluators.get();

        let
            value = false;

        if (evaluators?.length)
        {
            for (let i = 0; i < evaluators.length; i++)
            {
                if (evaluators[i].value.get())
                {
                    value = true;
                    break;
                }
            }
        }

        this.value.set(value);

        return value;
    }

    // #endregion
}

